


















































































































































































































































































































































































































































































































































































































































































































































































































import store, {
    GrowthRateSources,
    MonthlyPasture,
    Header,
    PastureKeys,
    PastureModel,
    PasturePair,
    PastureSimulation,
    Supply,
    Dataset
} from '../store'
// import moment from 'moment'
import dayjs from 'dayjs'
import {
    currentYearStartDate,
    daysInMonth,
    monthShortNames,
    MonthsInOrder,
    StartDates
} from '../common/dates'
import DatePicker from '../components/DatePicker.vue'
import ScrollButtons from '../components/ScrollButtons.vue'
import {
    Vue,
    Component,
    Watch
} from "vue-property-decorator";
import router from '@/router'

import LOCATIONS from '../data/locations';
import Confirm from '../components/Confirm.vue'
import { mod } from 'mathjs'
import { colors } from '@/common/colors'
import { platform } from '@/mla-shared'
import { cleanDate } from '@/filters/filters'
const PASTURES: PastureModel[] = require('../data/pastures.json')
const DMDI = require('../data/dmdi.json')

const PastureProps = Vue.extend({
    props: {},
    components: {
        DatePicker,
        ScrollButtons
    },
    store
});

@Component
export default class Pasture extends PastureProps {
    title:string = 'Pasture';
    months:string[] = monthShortNames;
    monthsDayCount:number[] = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    seasonalIndexes = {
        summer: [0, 1, 11],
        autumn: [2, 3, 4],
        winter: [5, 6, 7],
        spring: [8, 9, 10]
    };
    simulation: PastureSimulation = {
        name: 'Simulation 1',
        location: 1,
        date: currentYearStartDate,
        area: 0,
        areaIsEditable: false,
        enterprise: 'Cattle',
        growingWastage: 20,
        carryoverWastage: 20,
        soil: 'Clay',
        slope: 'Level',
        defaultScale: 1,
        growthRateSource: 'Add Pasture Types',
        customPastureQuality: 'No',
        pastures: [{
                name: 'p1',
                type: null,
                label: null,
                scale: 1
            },
            {
                name: 'p2',
                type: null,
                label: null,
                scale: 1
            }
        ]
    };
    items = {
        locations: LOCATIONS.map((e: any) => {
            return {
                text: e.Name,
                value: e.ID
            }
        }),
        scale: [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5],
        wastage: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
        enterprises: ['Cattle', 'Sheep', 'Cattle & Sheep'],
        soils: ['Clay', 'Clay Loam', 'Sandy Loam', 'Sand'],
        slopes: ['Level', 'Undulating', 'Steep'],
        growthRateSources: ['Add Pasture Types', 'User-supplied Average Values', 'Standard Average Values'],
        customPastureQualites: ['No', 'Yes']
    };
    monthlyPastureHeaders: Header[] = [{
            text: 'Month',
            value: 'month',
            align: 'start'
        },
        {
            text: 'Pasture 1',
            value: 'p1',
            align: 'center',
            class: ''
        },
        {
            text: 'Pasture 2',
            value: 'p2',
            align: 'center',
            class: ''
        },
        {
            text: 'Total Area',
            value: 'total',
            align: 'center',
            class: ''
        },
        {
            text: 'Average Growth',
            value: 'avgGrowth',
            align: 'center',
            
        },
        {
            text: 'Average Quality',
            value: 'avgQuality',
            align: 'center'
        },
        {
            text: 'Supplement',
            value: 'supplement',
            align: 'center',
            class: 'secondary'
        }
    ];
    monthlyPasture: MonthlyPasture[] = [];
    totalDm = {};

    // Chart
    plotType: string = "tonnes / ha";
	plotTypeItems = ["tonnes / ha", "tonnes/effective grazing area (total ha)"];
	chartType: string = "Bar";
	chartTypeItems = ["Bar", "Line", "Radar"];
    updateChart: number = 0;

    // Populate months on component create it does not exist
    created() {
        if (store.state.pasture !== null) {
            this.simulation = store.state.pasture.simulation
            this.monthlyPastureHeaders = store.state.pasture.monthlyPastureHeaders
            this.monthlyPasture = store.state.pasture.monthlyPasture
        } else {
            this.monthlyPasture = this.getMonthlyPasture()
        }
    }

    mounted(this:any) {
        if (this.$refs.form) {
            (this.$refs.form as Vue & { validate: () => boolean }).validate();
        }
    }

    // Watch for changes in monthlyPasture
    @Watch('monthlyPasture', {
        deep: true
    })
    onMonthlyPasture(val: any, oldVal: any) {
        if (!this.simulation.areaIsEditable) {
            this.simulation.area = parseFloat((this.monthlyPasture.map(mp => mp.total).reduce((a, b) => a + b) / 12).toFixed(2))
        }
        store.dispatch('updatePasture', this.$data)
    }

    // Watch for changes in simulation
    @Watch('simulation', {
        deep: true
    })
    onSimulation(val: any, oldVal: any) {
        store.dispatch('updatePasture', this.$data)
    }

    // Return errors array
    get errors(): string[] {
        return store.state.errors.pasture || []
    }

    // Return confirm dialogue reference
    get confirm(): Confirm {
        return this.$refs.confirm as Confirm;
    }

    // Return pasture types
    get types(): PastureModel[] {
        let types: PastureModel[] = []
        let startIndex = PASTURES.map((e: any) => e.LocationID).indexOf(this.simulation.location)
        let endIndex = PASTURES.map((e: any) => e.LocationID).indexOf(this.simulation.location + 1)

        for (let i = startIndex; i < endIndex; i++) {
            types[i - startIndex] = PASTURES[i]
        }

        store.state.types = types
        return types
    }

    // Return names of pasture types
    get typeNames(): string[] {
        return this.types.map((e) => e.Pasture)
    }

    // Return pasture keys
    get pastureKeys() {
        if (this.monthlyPasture.length > 0) {
            return Object.keys(this.monthlyPasture[0]).filter((e: any) => e.substr(0, 1) === 'p').map(p => p as PastureKeys)
        } else {
            return []
        }
    }

    // Return the tonnes DM per year / ha for each selected pasture
    get supply() {
        let supply: Supply = {}
        let tonnesDM: number[] = []
        let tonnesDMPerHa: number[] = []

        // Names of pastures
        let pastures: any[] = this.pastureKeys.map((key) => {
            return this.monthlyPasture[0][key].pasture.type
        })

        // For each pasture type
        for (let pk = 0; pk < this.pastureKeys.length; pk++) {
            let seasons = {
                summer: { total: 0, ha: 0 },
                autumn: { total: 0, ha: 0 },
                winter: { total: 0, ha: 0 },
                spring: { total: 0, ha: 0 }
            }

            // For each month
            for (let month = 0; month < 12; month++) {
                let growth:number = this.monthlyPasture[month][this.pastureKeys[pk]].growth
                let area:number = this.monthlyPasture[month][this.pastureKeys[pk]].area
                let days:number = this.monthsDayCount[month]

                // Pasture Growth in tonnes
                tonnesDM.push(growth * area * days * 0.001)
                let total:number = tonnesDM.reduce(function (prev, curr) {
                    return (Number(prev) || 0) + (Number(curr) || 0)
                })

                // Pasture Growth in tonnes per ha
                tonnesDMPerHa.push(tonnesDM[month] / area)
                let ha:number = tonnesDMPerHa.reduce(function (prev, curr) {
                    return (Number(prev) || 0) + (Number(curr) || 0)
                })

                // Seasonal totals
                if (this.seasonalIndexes.summer.includes(month)) {
                    seasons.summer.total += tonnesDM[month] || 0;
                    seasons.summer.ha += tonnesDMPerHa[month] || 0;
                }
                if (this.seasonalIndexes.autumn.includes(month)) {
                    seasons.autumn.total += tonnesDM[month] || 0;
                    seasons.autumn.ha += tonnesDMPerHa[month] || 0;
                }
                if (this.seasonalIndexes.winter.includes(month)) {
                    seasons.winter.total += tonnesDM[month] || 0;
                    seasons.winter.ha += tonnesDMPerHa[month] || 0;
                }
                if (this.seasonalIndexes.spring.includes(month)) {
                    seasons.spring.total += tonnesDM[month] || 0;
                    seasons.spring.ha += tonnesDMPerHa[month] || 0;
                }

                // Populate supply object
                supply[this.pastureKeys[pk]] = {
                    pasture: pastures[pk],
                    tonnesDM: tonnesDM,
                    tonnesDMPerHa: tonnesDMPerHa,
                    ha: ha,
                    carryOver: [],
                    total: total,
                    seasons: seasons
                }
            }
            tonnesDM = []
            tonnesDMPerHa = []
        }

        // console.log('Supply', supply)
        store.state.supply = supply
        return supply
    }

    // Return the total tonnes dm per ha or farm
    get totalTonnes() {
        const source:GrowthRateSources = this.simulation.growthRateSource
        let totals = {
            ha: 0,
            total: 0,
            seasons: {
                summer: { total: 0, ha: 0 },
                autumn: { total: 0, ha: 0 },
                winter: { total: 0, ha: 0 },
                spring: { total: 0, ha: 0 }
            }
        }

        this.hideHeaders(source)
        if (source === 'Add Pasture Types') {
            // Seasonal totals
            this.pastureKeys.forEach(pk => {
                for (let month = 0; month < 12; month++) {
                    if (this.seasonalIndexes.summer.includes(month)) {
                        totals.seasons.summer.total += this.supply[pk].tonnesDM[month] || 0;
                        totals.seasons.summer.ha += this.supply[pk].tonnesDMPerHa[month] || 0;
                    }
                    if (this.seasonalIndexes.autumn.includes(month)) {
                        totals.seasons.autumn.total += this.supply[pk].tonnesDM[month] || 0;
                        totals.seasons.autumn.ha += this.supply[pk].tonnesDMPerHa[month] || 0;
                    }
                    if (this.seasonalIndexes.winter.includes(month)) {
                        totals.seasons.winter.total += this.supply[pk].tonnesDM[month] || 0;
                        totals.seasons.winter.ha += this.supply[pk].tonnesDMPerHa[month] || 0;
                    }
                    if (this.seasonalIndexes.spring.includes(month)) {
                        totals.seasons.spring.total += this.supply[pk].tonnesDM[month] || 0;
                        totals.seasons.spring.ha += this.supply[pk].tonnesDMPerHa[month] || 0;
                    }
                }
            })
            // Yearly totals
            let tonnesDm:number = Object.keys(this.supply).reduce((previous, key) => { return previous + this.supply[key].total }, 0)
            totals.ha = (tonnesDm / this.simulation.area) || 0
            totals.total = tonnesDm || 0
        } else {
            let tonnesDm:number = 0
            for (let month = 0; month < 12; month++) {
                let increment = (0.001 * this.simulation.area * this.monthlyPasture[month].avgGrowth * this.monthsDayCount[month]) || 0;
                tonnesDm += increment
                // Seasonal totals
                if (this.seasonalIndexes.summer.includes(month)) {
                    totals.seasons.summer.total += increment;
                    totals.seasons.summer.ha += (increment / this.simulation.area) || 0;
                }
                if (this.seasonalIndexes.autumn.includes(month)) {
                    totals.seasons.autumn.total += increment;
                    totals.seasons.autumn.ha += (increment / this.simulation.area) || 0;
                }
                if (this.seasonalIndexes.winter.includes(month)) {
                    totals.seasons.winter.total += increment;
                    totals.seasons.winter.ha += (increment / this.simulation.area) || 0;
                }
                if (this.seasonalIndexes.spring.includes(month)) {
                    totals.seasons.spring.total += increment;
                    totals.seasons.spring.ha += (increment / this.simulation.area) || 0;
                }
            }
            // Yearly totals
            totals.ha = (tonnesDm / this.simulation.area) || 0
            totals.total = tonnesDm || 0
        }

        // console.log('Total tonnes dm', totals)
        return totals
    }
    set totalTonnes(newVal) {
        this.totalDm = newVal
    }

    // Get pasture months (default)
    getMonthlyPasture(): MonthlyPasture[] {
        let monthlyPastures: MonthlyPasture[] = []

        // For the months Jan - Dec [0-11]
        // Push new object month, each pasture area / type
        for (let i = 0; i < 12; i++) {
            monthlyPastures[i] = {
                month: this.months[i],
                avgGrowth: 0,
                avgQuality: 0,
                total: 0,
                p1: {
                    area: 0,
                    growth: 0,
                    quality: 0,
                    pasture: this.simulation.pastures[0],
                },
                p2: {
                    area: 0,
                    growth: 0,
                    quality: 0,
                    pasture: this.simulation.pastures[1],
                },
                supplement: {
                    amount: 0,
                    quality: 0
                }
            }
        }

        // console.log('Monthly pastures', monthlyPastures)
        return monthlyPastures
    }

    // Get area total for each month
    getAreaTotal(month: any) {
        const index: number = this.monthlyPasture.indexOf(month)
        let total: number = 0

        // If pasture type is set increment total
        this.pastureKeys.forEach((key) => {
            if (month[key] !== undefined) {
                if (month[key].pasture.type !== null) {
                    total += parseInt(month[key].area)
                }
            }
        })
        if (isNaN(total)) {
            total = 0
        }
        this.monthlyPasture[index].total = total

        // console.log('Total area', total);
        return total
    }

    // Get average growth rate for supplied month
    getAverageGrowth(month: MonthlyPasture) {
        const index = this.monthlyPasture.indexOf(month)
        let avgG:number = 0

        // Combined pasture growths rates
        if (this.simulation.growthRateSource === 'Add Pasture Types') {
            // ((growth1 * area1) + (growth2 * area2) + ...) / total area
            let totalArea:number = 0
            this.pastureKeys.forEach((key) => {
                if (month[key] !== undefined) {
                    if (month[key].pasture.type !== null) {
                        totalArea += month[key].area
                        avgG += month[key].growth * month[key].area
                    }
                }
            })
            avgG = avgG / totalArea
        // Standard growth rates
        } else {
            avgG = LOCATIONS[this.simulation.location - 1].StdPastureGrowth[index]
        }

        // Adjust scale
        if (this.simulation.growthRateSource === 'Standard Average Values') {
            avgG = avgG * this.simulation.defaultScale
        }

        // Update monthly values
        this.monthlyPasture[index].avgGrowth = avgG

        if (isNaN(avgG)) {
            return 0
        }

        // console.log('Average growth', avgG)
        return avgG
    }

    // Get average quality for supplied month
    getAverageQuality(month: MonthlyPasture) {
        const index:number = this.monthlyPasture.indexOf(month)
        let avgQ:number = 0

        // Combined pasture quality
        if (this.simulation.growthRateSource === 'Add Pasture Types') {
            let areas:number[] = []
            let growths:number[] = []
            let tabularDmdis:number[] = []
            let sumArea:number = 0
            let sumAreaGrowth:number = 0
            let sumAreaGrowthDmdi:number = 0
            let sumTabularDmdis:number = 0
            let pastureTypesSelected:boolean = false
    
            this.pastureKeys.forEach((key) => {
                if (month[key] !== undefined) {
                    if (month[key].pasture.type !== null) {
                        pastureTypesSelected = true
                        areas.push(month[key].area)
                        growths.push(month[key].growth)
                        tabularDmdis.push((month[key].quality + 2) / 17)
                    }
                }
            })

            areas.map((a:number, pIndex:number) => {
                sumArea += areas[pIndex]
                sumAreaGrowth += areas[pIndex] * growths[pIndex]
                sumAreaGrowthDmdi += areas[pIndex] * growths[pIndex] * tabularDmdis[pIndex]
                sumTabularDmdis += tabularDmdis[pIndex]
            })

            let dmdi:number = 0;
            if (sumArea <= 0) {
                dmdi = sumTabularDmdis / this.pastureKeys.length
            } else {
                dmdi = sumAreaGrowthDmdi / sumAreaGrowth
            }

            if (pastureTypesSelected) {
                avgQ = 17 * dmdi - 2
            }
        // Standard quality
        } else {
            let weightings = {
                cattle: 0.5,
                sheep: 0.5
            }
            switch (this.simulation.enterprise) {
                case 'Cattle':
                    weightings.sheep = 0
                    break;
                case 'Sheep':
                    weightings.cattle = 0
                    break;
                case 'Cattle & Sheep':
                    weightings.cattle = 0.25
                    weightings.sheep = 0.25
                    break;
                default:
                    break;
            }

            avgQ = 17 * (
                (weightings.cattle * LOCATIONS[this.simulation.location - 1].StdDmdiCattle[index * 2]) +
                (weightings.cattle * LOCATIONS[this.simulation.location - 1].StdDmdiCattle[(index * 2) + 1]) +
                (weightings.sheep * LOCATIONS[this.simulation.location - 1].StdDmdiSheep[index * 2]) +
                (weightings.sheep * LOCATIONS[this.simulation.location - 1].StdDmdiSheep[(index * 2) + 1])
            ) - 2
        }

        this.monthlyPasture[index].avgQuality = avgQ

        if (isNaN(avgQ)) {
            return 0
        }

        // console.log('Average Quality', avgQ)
        return avgQ
    }

    // Value change event
    // event === new value
    // month === object (month row)
    // unit === object property values (area, growth, quality, pasture)
    // pasture === object property name (p1, p2, p3)
    changeMonthly(event: any, month: MonthlyPasture, unit ? : string, pasture ? : PastureKeys) {
        let index = this.monthlyPasture.indexOf(month)
        switch (unit) {
            case 'area':
                this.monthlyPasture[index][pasture!].area = parseFloat(event)
                break
            case 'growth':
                this.monthlyPasture[index][pasture!].growth = parseFloat(event)
                break
            case 'quality':
                this.monthlyPasture[index][pasture!].quality = parseFloat(event)
                break
            case 'avgGrowth':
                this.monthlyPasture[index].avgGrowth = parseFloat(event)
                break
            case 'avgQuality':
                this.monthlyPasture[index].avgQuality = parseFloat(event)
                break
            case 'supplementAmount':
                this.monthlyPasture[index].supplement.amount = parseFloat(event)
                break
            case 'supplementQuality':
                this.monthlyPasture[index].supplement.quality = parseFloat(event)
                break
            default:
                break
        }
        this.updateChart += 1;
    }

    // Update default growth and quality values on pasture type select
    changePasture(pasture: PasturePair) {
        let index:number = this.types.map((e) => e.Pasture).indexOf(pasture.type!)
        let growths:number[] = this.types[index].Months

        // Get DMDI values for default quality
        let pastures = PASTURES.filter((e: any) => e.LocationID === this.types[index].LocationID)
        let activePasture = pastures[pastures.map((e: any) => e.Pasture).indexOf(this.types[index].Pasture)]
        let activePastureDMDI = DMDI[store.state.enterprise === 'Sheep' ? 'sheep' : 'cattle'][activePasture.ID - 1]
        let activePastureDMDICondensed: any[] = []
        let activePastureKeys = Object.keys(activePastureDMDI)

        for (let i = 0; i < activePastureKeys.length; i++) {
            activePastureDMDICondensed.push((activePastureDMDI[activePastureKeys[i]] + activePastureDMDI[activePastureKeys[i + 1]]) / 2)
            i += 1
        }

        // Push default values to each month of selected pasture
        for (let i = 0; i < 12; i++) {
            this.monthlyPasture[i][pasture.name].growth = growths[i]
            this.monthlyPasture[i][pasture.name].quality = 17 * activePastureDMDICondensed[i] - 2
            this.monthlyPasture[i][pasture.name].pasture = pasture
        }
    }

    // Change monthly scale
    changeScale(this:any, newScale:number, pasture: PasturePair) {
        const index = this.simulation.pastures.indexOf(pasture)
        const originalScale = 1
        const previousScale = this.simulation.pastures[index].scale
        let revert = originalScale / previousScale
        // Update growths
        for (let i = 0; i < 12; i++) {
            this.monthlyPasture[i][pasture.name].growth = (this.monthlyPasture[i][pasture.name].growth * revert) * newScale
        }
        // Update scale
        this.simulation.pastures[index].scale = newScale
        this.updateChart += 1
    }

    // Add new pasture type / column
    add() {
        let pNum:number = (this.simulation.pastures.length + 1)
        let pName:string = 'p' + pNum

        // Find the first number that is not being used and append to 'p'
        while (this.simulation.pastures.map((e: any) => e.name).indexOf(pName) > -1) {
            pNum -= 1
            pName = 'p' + pNum
        }

        // Set reactive default values
        this.$set(
            this.simulation,
            'pastures',
            [...this.simulation.pastures, { name: pName, type: null, scale: 1 }]
        )
        for (let i = 0; i < this.monthlyPasture.length; i++) {
            this.$set(
                this.monthlyPasture[i],
                pName,
                {
                    area: 0,
                    growth: 0,
                    quality: 0,
                    pasture: this.simulation.pastures[this.simulation.pastures.map((e: any) => e.name).indexOf(pName)],
                    total: 0
                }
            )
        }

        // Sort pastures
        this.$set(
            this.simulation,
            'pastures',
            this.simulation.pastures.sort((a, b) => (a.name > b.name) ? 1 : -1)
        )

        // Add to pasture headers
        this.monthlyPastureHeaders.splice(pNum, 0, {
            text: 'Pasture ' + pNum,
            value: pName,
            align: 'center'
        })

        // Sort headers
        let pHeaders = this.monthlyPastureHeaders.filter(mph => mph.text.startsWith('Pasture'))
        let startIndex = this.monthlyPastureHeaders.map(mph => mph.value).indexOf(pHeaders[0].value)
        this.monthlyPastureHeaders.splice(startIndex, pHeaders.length, ...pHeaders.sort((a, b) => (a.value > b.value) ? 1 : -1))
        this.updateChart += 1
    }

    // Remove pasture type / column
    async remove(pasture: any, index: number) {
        if (await this.confirm.open('Delete', 'Are you sure you want to delete this pasture?', {
                color: 'red'
            })) {
            this.monthlyPasture = this.monthlyPasture.map((e: any) => {
                delete e[pasture.name]
                return e
            })
            let headerIndex:number = this.monthlyPastureHeaders.map((e: any) => e.value).indexOf(pasture.name)
            this.monthlyPastureHeaders.splice(headerIndex, 1)
            this.simulation.pastures.splice(index, 1)
        }
        this.updateChart += 1
    }

    // Hide heads bases on growth rate source selection
    hideHeaders (source:GrowthRateSources) {
        this.monthlyPastureHeaders.map((mph: Header, index: number) => {
            if (mph.text.startsWith('Pasture') || mph.text === ('Total Area')) {
                if (source !== 'Add Pasture Types') {
                    this.monthlyPastureHeaders[index].class = 'd-none'
                } else {
                    this.monthlyPastureHeaders[index].class = ''
                }
            }
        })
    }

    // Start date change
    dateChange(newDate: any) {
        this.simulation.date = dayjs(newDate).format('YYYY-MM-DD')
        this.updateChart += 1
    }

    // Toggle effective area value
    toggleEffectiveArea() {
        this.simulation.areaIsEditable = !this.simulation.areaIsEditable
        // If not editable then use default
        if (!this.simulation.areaIsEditable && this.simulation.growthRateSource === 'Add Pasture Types') {
            this.simulation.area = parseFloat((this.monthlyPasture.map(mp => mp.total).reduce((a, b) => a + b) / 12).toFixed(2))
        }
    }

    // Handle growth rate source change
    growthRateSourceChange(grs:GrowthRateSources) {
        // By default, set effective area to read only
        if (grs === 'Add Pasture Types') {
            this.simulation.areaIsEditable = false
        } else {
            this.simulation.areaIsEditable = true
        }
        this.updateChart += 1;
    }

    // Validation
    async validate() {
        let valid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
        let title = ''
        let message = ''
        let status = false

        // Missing required data
        if (this.errors && this.errors.length > 0) {
            title = 'Invalid fields:'
            status = false
            message = this.errors.join(", ")
        // Invalid data
        } else if (!valid) {
            title = 'Invalid data'
            status = false
            message = 'Please correct the invalid data highlighted in red.'
        // Missing pasture selection
        } else if (this.simulation.growthRateSource === 'Add Pasture Types' && this.simulation.pastures.filter(p => p.type === null).length > 0) {
            title = 'Pasture type/s missing'
            status = false
            message = 'Please select a pasture type for all columns or delete it from the pastures table.'
        // Invalid effective area
        } else if (this.simulation.area <= 0) {
            title = 'Invalid effective area'
            status = false
            message = 'Effective area value cannot be equal to 0.'
        // No errors
        } else {
            status = true
        }

        // If no errors continue to destination route
        if (status === true) {
            router.push('/livestock')
        } else {
            await this.confirm.open(title.length > 0 ? title : 'Error', message, {
                color: 'red',
                cta: 'Okay'
            })
        }
    }

    // Chart

    get chartOptions() {
		return {
			responsive: true,
			maintainAspectRatio: true,
			aspectRatio: this.$vuetify.breakpoint.width < 768 ? 1.5 : 3,
			resizeDelay: 1000,
			interaction: {
				mode: "index",
				intersect: false
			},
			scales: {
				x: {
					display: this.chartType !== "Radar",
					position: "bottom",
					stacked: true,
					beginAtZero: true,
					title: {
						display: true,
						text: "Month",
						color: "#000",
						font: {
							size: 14
						},
						padding: {
							top: 15
						}
					},
					ticks: {
						color: "#000"
					},
					grid: {
						color: "rgba(0,0,0,0.05)",
						tickColor: "#000",
						borderColor: "#000"
					}
				},
                y: {
                    display: true,
                    stacked: true,
                    type: "linear",
                    position: "left",
                    beginAtZero: true,
                    grace: "5%",
                    ticks: {
                        precision: 4,
                        color: "#000"
                    },
                    grid: {
						color: "rgba(0,0,0,0.05)",
						tickColor: "#000",
						borderColor: "#000"
					},
                    title: {
                        display: true,
                        text:
                        "Pasture " +
                        (this.plotType === "tonnes / ha"
                        ? "(tonnes DM/ha)"
                        : "(tonnes DM)"),
                        color: "#000",
                        font: {
                            size: 14
                        },
                        padding: {
                            bottom: 15
                        }
                    }
                }
            },
            plugins: {
                chartAreaBorder: {
                    borderColor: "rgba(0,0,0,0.1)",
                    borderWidth: 1
                },
                tooltip: {
                    filter: function(tooltipItem: any) {
                        return tooltipItem.dataset.pointStyle != "triangle" && tooltipItem.raw > 0;
                    },
                    callbacks: {
                        label: function(context: any) {
                            let yLabel: string = "";
                            if (context.formattedValue !== null) {
                                yLabel += parseFloat(context.raw.toFixed(5))
                            }
                            if (context.raw > 0) {
                                return context.dataset.label + ": " + yLabel;
                            }
                        },
                        labelColor: function(context: any) {
                            let dataset =
                                context.chart.config.data.datasets[
                                    context.datasetIndex
                                ];
                            return {
                                borderColor:
                                    dataset.backgroundColor != "transparent"
                                        ? dataset.backgroundColor
                                        : dataset.borderColor,
                                backgroundColor:
                                    dataset.backgroundColor != "transparent"
                                        ? dataset.backgroundColor
                                        : dataset.borderColor
                            };
                        },
						footer: (tooltipItems:any) => {
                            if (this.simulation.growthRateSource === 'Add Pasture Types') {
                                let total:number = 0;
                                tooltipItems.map((a:any) => { total += a.raw });
                                return 'Total supply: ' + parseFloat(total.toFixed(2));
                            }
						}
                    }
                },
                legend: {
                    display: true,
                    position: "top",
                    labels: {
                        usePointStyle: true,
                        boxWidth: 12,
                        color: "#000",
                        font: {
                            size: 16
                        },
                        filter: function(legendItem: any, chart:any) {
                            let sum:number = 0
                            if (chart.datasets[legendItem.datasetIndex].data.length > 0) {
                                sum = chart.datasets[legendItem.datasetIndex].data.reduce((a:number, b:number) => a + b)
                            }
                            if (legendItem.text && sum != 0) {
                                return legendItem.text;
                            }
                        },
                        generateLabels: function(chart: any) {
                            var data = chart.data;
                            var legends = Array.isArray(data.datasets)
                                ? data.datasets.map(function(
                                        dataset: any,
                                        i: number
                                    ) {
                                        return {
                                            text: dataset.label,
                                            datasetIndex: i,
                                            fillStyle: dataset.borderDash
                                                ? "transparent"
                                                : dataset.backgroundColor,
                                            hidden: !chart.isDatasetVisible(i),
                                            pointStyle: "rect",
                                            borderRadius: 0
                                        };
                                    },
                                    this)
                                : [];
                            return legends;
                        }
                    }
                }
            }
		}
	}

    get chartPeriods() {
        let periods: number[] = [];
        for (let i = 0; i < 24; i++) {
            if (i === 0) {
                periods.push(
                StartDates.indexOf(
                    dayjs(this.simulation.date).format("D MMM")
                ) + 1
                );
            } else {
                periods.push(mod(1 + periods[i - 1], 24));
            }
        }
        return periods
    }

    get chartMonths() {
        let months: number[] = [];
            for (let period = 0; period < 24; period++) {
            if (period % 2 === 0) {
                months.push(
                    dayjs(cleanDate(StartDates[mod(this.chartPeriods[period] - 1, 24)], 'D MMM'), 'D MMM').month()
                );
            }
        }
        return months
    }

    get chartPastureGrowthResults() {
        const vm = this
        function pastureGrowth(pastureKey?:PastureKeys) {
            // Pasture Growth
            let pasture: any = {
                area: [],
                tonnesMonth: [],
                daysMonth: []
            };
            for (let month = 0; month < 12; month++) {
                const daysMonth = daysInMonth[monthShortNames[vm.chartMonths[month]].toLowerCase()]
                const monthlyPasture = vm.monthlyPasture[vm.chartMonths[month]]
                // Pasture Area
                let area = 0
                if (pastureKey) {
                    area = monthlyPasture[pastureKey].area
                } else {
                    if (vm.simulation.growthRateSource === 'Add Pasture Types') {
                        area = monthlyPasture.total
                    } else {
                        area = vm.simulation.area
                    }
                }
                pasture.area.push(area);
                // Pasture growth kg/ha/d
                let growth = 0
                if (monthlyPasture) {
                    if (pastureKey) {
                        growth = monthlyPasture[pastureKey].growth
                    } else {
                        growth = monthlyPasture.avgGrowth
                    }
                }
                if (daysMonth) {
                    // Tonnes per month
                    pasture.tonnesMonth.push(
                    0.001 *
                    area *
                    growth *
                    daysMonth
                    );
                    // Days in month
                    pasture.daysMonth.push(daysMonth)
                }
            }
            return pasture
        }

        // Total pasture
        let totalPastureGrowth:any = pastureGrowth()

        // Single Pasture
        let singlePastureGrowth:any = {}
            this.simulation.pastures.forEach((pasture:any) => {
            singlePastureGrowth[pasture.name] = pastureGrowth(pasture.name)
        });

        let pastureGrowthResults = {
            total: totalPastureGrowth,
            pastures: singlePastureGrowth
        }

        return pastureGrowthResults
    }

    get chartData() {
		let datasets: Dataset[] = [];
        const pasture = this.chartPastureGrowthResults

        // Return month in correct order from start date
        const monthsInOrder = MonthsInOrder(this.simulation.date).map(m => ({
            name: monthShortNames[m - 1],
            month: m
        }));

        // Format HSLA
        const format = function ({ h, s, l, a }: { h: number; s: number; l: number; a?: number }) {
            return `hsla(${h}, ${s}%, ${l}%, ${a || 1})`;
        }

        // Color HSLA
        const color = function ({ h, s, l, a }: { h: number; s: number; l: number; a?: number }) {
            return {
                value: format({ h, s, l, a }),
                h,
                s,
                l,
                a,
                format: format
            };
        }

        // Generate random HSL color
        const randomColor = function() {
            return color({
                h: Math.floor(Math.random() * 60) + 15,
                s: Math.floor(Math.random() * 50) + 25,
                l: Math.floor(Math.random() * 25) + 25,
                a: 1
            });
        }

        // Freshly Grown Supply (Pastures)
		if (
			this.types &&
			this.simulation.growthRateSource === "Add Pasture Types"
		) {
			for (let i = 0; i < this.pastureKeys.length; i++) {
				const color = randomColor();
				const freshSupplyColour = color.format({
					...color,
					a: 0.7
				});

				const pastureKey = this.pastureKeys[i] as PastureKeys;
				const freshSupply = this.supply[pastureKey].tonnesDM;
				let label = this.supply[this.pastureKeys[i]].pasture;

				// Use custom labels if they exist
				if (this.simulation.pastures[i].label) {
					label = this.simulation.pastures[i].label as string;
				}


                datasets.push({
                    yAxisID: "y",
                    label: label,
                    backgroundColor: freshSupplyColour,
                    borderColor: 'black', // freshSupplyColour,
                    borderWidth: 0.5,
                    pointStyle: 'rect',
                    pointBorderColor: 'rgba(0, 0, 0, 0.5)',
                    data: monthsInOrder.map((mx, month: number) => {
                        if (this.plotType === "tonnes/effective grazing area (total ha)") {
                            return freshSupply[mx.month - 1];
                        } else {
                            let divisor = pasture.total.area[month];
                            return freshSupply[mx.month - 1] / (divisor > 0 ? divisor : 1);
                        }
                    }),
                    fill: false,
                    lineTension: 0,
                    order: 0,
                    hidden: false
                });
            }
        // Freshly Grown Supply (Total)
		} else {
            const freshSupply = pasture.total.tonnesMonth.map(
                (tm: number, index: number) => {
                    if (this.plotType === "tonnes/effective grazing area (total ha)") {
                        return tm
                    } else {
                        let divisor = pasture.total.area[index]
                        return tm / (divisor > 0 ? divisor : 1);
                    }
                }
            );

            datasets.push({
                yAxisID: "y",
                label: "Freshly grown supply",
                backgroundColor: colors.other["Fresh grown supply"],
                borderColor: 'black', // colors.other["Fresh grown supply"],
                borderWidth: 0.5,
                pointStyle: 'rect',
                pointBorderColor: 'rgba(0, 0, 0, 0.5)',
                data: freshSupply.map((tm: number, month: number) => {
                    if (this.plotType === "tonnes/effective grazing area (total ha)") {
                        return tm;
                    } else {
                        let divisor = pasture.total.area[month];
                        return tm / (divisor > 0 ? divisor : 1);
                    }
                }),
                fill: false,
                lineTension: 0,
                order: 0,
                hidden: false
            });
        }

        // Supplement

        let suppPasture: any = { area: [] };
        let supplementData: any = {
            amount: [],
            tonnesMonth: [],
            demandNotMetBySupplement: [],
        };
        for (let month = 0; month < 12; month++) {
            // Pasture Area
            suppPasture.area.push(
                this.simulation.area
            );
            // kg/ha/d
            supplementData.amount.push(
                this.monthlyPasture[this.chartMonths[month]].supplement.amount
            )
            // Supplement tonnes per month
            supplementData.tonnesMonth.push(
                0.001 *
                suppPasture.area[month] *
                    supplementData.amount[month] *
                    daysInMonth[monthShortNames[this.chartMonths[month]].toLowerCase()]
            );
        }

		datasets.push({
            yAxisID: "y",
            label: "Supplement",
            backgroundColor: colors.other["Supplement"],
            borderColor: 'black', // colors.other["Supplement"],
            borderWidth: 0.5,
            pointStyle: 'rect',
            pointBorderColor: 'rgba(0, 0, 0, 0.5)',
            data: supplementData.tonnesMonth.map((tpm: any, index: number) => {
                if (this.plotType === "tonnes/effective grazing area (total ha)") {
                    return (tpm * (pasture.total.area[index] / this.simulation.area));
                } else {
                    return tpm / this.simulation.area;
                }
            }),
            fill: false,
            lineTension: 0,
            order: 1,
            hidden: false
		});

        return {
			labels: monthsInOrder.map(m => m.name),
			datasets: datasets
		};
    }

    // Print page
	async print() {
		if (platform() == "web") {
			await print();
		} else {
			const scanvas: HTMLCanvasElement | null = document.getElementById(
				"supplyDemand"
			) as HTMLCanvasElement;
			if (scanvas && scanvas.parentElement) {
				const img = document.createElement("img");
				if (img) {
					img.src = scanvas.toDataURL();
					img.style.width = `${scanvas.clientWidth}px`;
					img.style.height = `${scanvas.clientHeight}px`;
					scanvas.parentElement.insertBefore(
						img,
						scanvas.nextSibling
					);
					const previousDisplay = scanvas.style.display;
					scanvas.style.display = "none";

					await print();

					if (scanvas && img.parentElement) {
						img.parentElement.removeChild(img);
						scanvas.style.display = previousDisplay;
					}
				} else {
					await print();
				}
			} else {
				await print();
			}
		}
    }
}
